export type SerializedRelation = {id: number, id_from: number, id_to: number, match: boolean, obsolete: boolean};
import { DataSet, Edge } from 'ngx-vis';

export class Relation {
    private pIdFrom: number;
    private pIdTo: number;
    private pMatchingRelation: boolean;
    private pObsolete: boolean;
    private pRelationId: number;

    constructor(idFrom: number, idTo: number) {
        this.pIdFrom = idFrom;
        this.pIdTo = idTo;
        this.pMatchingRelation = false;
        this.pObsolete = false;
        this.pRelationId = NaN;
    }

    relation_exists(idFrom: number, idTo: number): boolean {
        if (this.pIdFrom === idTo && this.pIdTo === idFrom) {
            return true;
        } else {
            return false;
        }
    }

    get is_obsolete(): boolean {
        return this.pObsolete;
    }

    set_obsolete(): void {
        this.pObsolete = true;
    }

    set_matching_relation(): void {
        this.pMatchingRelation = true;
    }

    get is_matching_relation(): boolean {
        return this.pMatchingRelation;
    }

    get from(): number {
        return this.pIdFrom;
    }

    get to(): number {
        return this.pIdTo;
    }

    get id(): number {
        return this.pRelationId;
    }

    set_relation_id(id): void {
        this.pRelationId = id;
    }

    get relation_node_data(): Edge {
        if (this.pMatchingRelation) {
            return {id: this.pRelationId, from: this.pIdFrom, to: this.pIdTo, value: 6, color: 'rgb(129,255,204)'};
        }
        else {
            return {id: this.pRelationId, from: this.pIdFrom, to: this.pIdTo, arrows: 'to', color: 'rgb(0,0,0)'};
        }
    }

    get serialize(): SerializedRelation {
        return {id: this.pRelationId, id_from: this.pIdFrom, id_to: this.pIdTo, match: this.pMatchingRelation, obsolete: this.pObsolete};
    }

    deserialize(json: SerializedRelation): void {
        this.pIdFrom = json.id_from;
        this.pIdTo = json.id_to;
        this.pMatchingRelation = json.match;
        this.pObsolete = json.obsolete;
        this.pRelationId = json.id;
    }
}